// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:52
import { FileChunk_abstract } from './../abstract/SagaSchema/FileChunk_abstract';
export class FileChunk extends FileChunk_abstract {}
